import styled, { keyframes } from "styled-components";

import bgImg from "../../../assets/bg-icons.png";

import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  /* align-items: center; */
  align-items: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ContentGeral = styled.div`
  width: 85%;
  max-width: 768px;
  min-width: 275px;
  margin-top: 40px;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-items: center;

  * {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: row;
  justify-content: space-around;

  @media (max-width: 425px) {
    width: 95%;
    flex-direction: column;
    margin: 40px 10px;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const CardGeral = styled.div`
  margin: 10px;
  min-width: 180px;
  max-width: 100%;
  min-height: 50px;
  flex: 1;
  margin-top: 30px;
  padding-bottom: 15px;


  background-color: #eee;
  border-radius: 10px;
  box-shadow: 2px 2px 5px;

  /* overflow: hidden; */

  display: flex;
  align-items: center;
  flex-direction: column;

  animation: ${opacity} 0.5s;

  > h1 {
    font-size: clamp(35px, 35px + 1vw, 72px);
    margin: 10px 0px;

    color: var(--darkGreen);
  }

  > h4 {
    text-align: center;
  }

  @media (max-width: 425px) {
    flex: none;
    width: calc(100% - 20px);
  }
`;

export const Content = styled.div`
  width: 85%;
  max-width: 768px;
  min-width: 275px;
  height: fit-content;
  margin: 20px 10px;
  z-index: 1;

  border-radius: 10px;

  animation: ${fadeIn} 0.4s;

  > h1 {
    margin-bottom: 10px;
  }

  @media (max-width: 425px) {
    width: 90%;
    margin: 40px 10px;
  }
`;

export const Card = styled.section`
  padding: 10px;
  margin-bottom: 10px;

  border-radius: 10px;

  > h1 {
    font-size: 25px;
    margin-bottom: 10px;

    >a {
      font-size: 14px;
      font-weight: normal;
      text-decoration: none;
      font-weight: bold;

      color: var(--green);
      cursor: pointer;

      :hover{
        text-decoration: underline;
      }

    }
  }
`;

export const Icon = styled.img`
  width: 60px;
  margin: 5px;
  margin-top: -30px;

  background-color: var(--white);
  border-radius: 50%;
  padding: 5px;
  object-fit: scale-down;
`;

export const LinkMenu = styled(Link)`
  color: var(--black);
  width: 100px;

  text-decoration: none;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.6;
  }
`;
